import React from 'react'
import addeventsteptwoStyle from './AddEventMobilStepTwo.module.css'
import CoordinatorAccordion from '../../components/Accordion/CoordinatorAccordion'

export default function AddEventMobilStepTwo() {
  return (
    <div className={addeventsteptwoStyle.aemsTwopage}>
      <div className='row'>
        <div className="col-lg-12">
          <h4 className={addeventsteptwoStyle.addeventtitleauthorMobil}> Author/s </h4>
          <div className={addeventsteptwoStyle.addeventMobilauthorwrap}>
            <CoordinatorAccordion />
          </div>
        </div>
      </div>
    </div>
  )
}
